import * as React from 'react';

function ProductStructuredData({
  description,
  title,
  images,
  sku,
  url,
  model,
  category,
  height,
  width,
  depth
}) {
  // Build the base metadata object
  const metadata = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: title,
    description,
    model,
    category,
    image: images?.[0]?.asset?.url ? [images[0].asset.url] : undefined,
    url,
    sku,
    height: height ? `${height} cm` : undefined,
    width: width ? `${width} cm` : undefined,
    depth: depth ? `${depth} cm` : undefined,
    offers: {
      '@type': 'Offer',
      price: '0',
      url,
      availability: 'https://schema.org/InStock',
      priceCurrency: 'EUR',
      priceSpecification: {
        '@type': 'PriceSpecification',
        priceCurrency: 'EUR',
        price: '0'
      },
      eligibleRegion: {
        '@type': 'Place',
        name: 'Ireland'
      },
      seller: {
        '@type': 'Organization',
        name: 'Connolly Stairs & Doors'
      }
    },
    additionalType: 'http://schema.org/Offer',
    potentialAction: {
      '@type': 'Action',
      name: 'Request a Quote',
      target: 'https://www.connollystairs.ie/request-a-quote/'
    }
  };

  // Remove keys with invalid values
  const filteredMetadata = Object.fromEntries(
    Object.entries(metadata).filter(
      ([, value]) =>
        value !== undefined && value !== null && !(typeof value === 'string' && value.trim() === '')
    )
  );

  return <script type="application/ld+json">{JSON.stringify(filteredMetadata)}</script>;
}

export default ProductStructuredData;
